export default __webpack_public_path__ + "static/media/nodejs.e10e38b0.png";